// extracted by mini-css-extract-plugin
module.exports = {"comments":"S_dv","comments__list":"S_dw"};